var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlexabilityMobileBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 613,
    viewBox: "0 0 430 613",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.32 95.9953C201.428 84.1191 212.155 54.138 200.278 29.0302C188.403 3.92251 158.422 -6.8041 133.314 5.07172C108.207 16.9475 97.4801 46.9286 109.355 72.0364C121.232 97.1441 151.213 107.871 176.32 95.9953Z",
    fill: "url(#paint0_radial_175_1111)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.41 208.154C208.975 184.632 306.324 243.846 329.846 340.411C353.367 436.975 294.155 534.325 197.59 557.846C101.025 581.368 3.67571 522.154 -19.8459 425.59C-43.3676 329.025 15.8456 231.676 112.41 208.154Z",
    fill: "url(#paint1_radial_175_1111)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_175_1111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.759 45.851) rotate(14.976) scale(89.6374 103.549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6036,
    stopColor: "#074F78",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25D28A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_175_1111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.6237 454.15) rotate(-31.7154) scale(325.861 298.567)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827187,
    stopColor: "#2B0B3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7484D5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexabilityMobileBg);
export default __webpack_public_path__ + "static/media/flexabilityMobileBg.e306803bddaa19e5c72d46b7cb59f992.svg";
export { ForwardRef as ReactComponent };